export default {
  selectedNode: null,
  selectedGraph: null,
  school: null
}
